export const VIEWS = Object.freeze({
  LIST: 'list',
  SEARCH: 'search',
  CONVERSATION: 'conversation',
  NEW_MESSAGE: 'newMessage',
  NEW_GROUP: 'newGroup',
  PUBLIC_GROUPS: 'publicGroups',
  MANAGE_MEMBERS: 'manageMembers',
  HIDDEN_MESSAGES: 'hiddenMessages',
  FAVORITE_MESSAGES: 'favoriteMessages',
  BLOCKED_CONTACTS: 'blockedContacts',
});

export const DIALOGS = Object.freeze({
  GROUP_INFO: 'groupInfo',
  REPORT: 'report',
  GROUP_ACTIONS: 'groupActions',
  GROUP_MEMBERS_PREVIEW: 'groupMembersPreview',
  DM_ACTIONS: 'dmActions',
  MAIN_MENU: 'mainMenu',
  ACTIVE_STATUS: 'activeStatus',
  CHAT_STATUS: 'chatStatus',
  DELETE_MESSAGE: 'deleteMessage',
  DELETE_MESSAGE_FOR_ME: 'deleteMessageForMe',
});
